import React from 'react'
import { colors } from '../consts'
import { styled } from '@mui/system'

type BarProps = {
  fillColor: string
  filledWidth: number
  totalWidth: number
  barWidthPct?: number
  emptyWidth?: number
  side: string
}

type BarFillProps = {
  fillColor?: string
  barWidthPct?: number
  filledWidth?: number
  emptyWidth?: number
  side: string
}

export const DefaultBar = styled('div')<BarFillProps>(({ side, barWidthPct = 100, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: side === 'left' ? 'flex-start' : 'flex-end',
  height: 15,
  width: `${barWidthPct}%`,
  margin: theme.spacing(0.5, 0),
  [theme.breakpoints.down('md')]: {
    height: 7,
  },
}))

export const FilledBar = styled('div')<BarFillProps>(
  ({ filledWidth, fillColor, side, theme }) => ({
    height: 15,
    width: `${filledWidth}%`,
    backgroundColor: fillColor,
    borderRadius: side === 'left' ? '0 5px 5px 0' : '5px 0 0 5px',
    [theme.breakpoints.down('md')]: {
      height: 7,
    },
  })
)

export const UnFilledBar = styled('div')<BarFillProps>(({ theme, side, emptyWidth }) => ({
  height: 15,
  width: `${emptyWidth}%`,
  backgroundColor: colors.gray.gray20,
  borderRadius: side === 'left' ? '5px 0 0 5px' : '0 5px 5px 0',
  [theme.breakpoints.down('md')]: {
    height: 7,
  },
}))

export const Bar: React.FC<React.PropsWithChildren<BarProps>> = ({
  side,
  fillColor,
  filledWidth,
  totalWidth,
  barWidthPct = 100,
}) => {
  const filledW = (filledWidth / totalWidth) * 100
  const empty = filledWidth ? ((totalWidth - filledWidth) / totalWidth) * 100 : 100

  return (
    <DefaultBar side={side} barWidthPct={barWidthPct}>
      {side === 'left' && (
        <>
          <UnFilledBar emptyWidth={empty} side={side} />
          <FilledBar side={side} filledWidth={filledW} fillColor={fillColor} />
        </>
      )}
      {side === 'right' && (
        <>
          <FilledBar side={side} filledWidth={filledW} fillColor={fillColor} />
          <UnFilledBar emptyWidth={empty} side={side} />
        </>
      )}
    </DefaultBar>
  )
}
